import Avatar from "@mui/material/Avatar";
import { SxProps } from "@mui/system";
import { getNameInitials } from "utils/helpers";
import { styles } from "./styles";

interface IAvatar {
  name?: string;
  src?: string;
  className?: string;
  sx?: SxProps;
}

export default function CustomAvatar({ name, src, className, sx }: IAvatar) {
  const classes = styles();

  return (
    <Avatar
      src={src}
      alt={name || "avatar"}
      sx={{ ...sx }}
      className={`${classes.avatar} ${className}`}
      imgProps={{ loading: "lazy" }}
    >
      {getNameInitials(name || "")}
    </Avatar>
  );
}
